module.exports = __webpack_public_path__ + "img/c1.24d2f33b.png";